import $ from 'jquery';
import gsap from 'lib/shim/gsap';

var __$html = $('html');
var __timeline;

export default {
  open: function () {
    __timeline = new gsap.TimelineLite();

    __timeline
      .to('#filters-panel', 0, { left: 0, visibility: 'initial' })
      .from('#filters-panel', 0.25, {
        opacity: 0,
        onComplete: function () {
          __$html.addClass('filters-open');
        }
      })
      .staggerFrom(
        '#filters-panel .sticky li:visible, #filters-panel .sticky > div',
        0.25, // duration of entire animation
        {
          marginLeft: '25%',
          opacity: 0,
          clearProps: 'all'
        },
        0.03 // stagger time,
      );
  },

  close: function () {
    __timeline
      .to('#filters-panel', 0.25, {
        opacity: 0,
        clearProps: 'all',
        onComplete: function () {
          __$html.removeClass('filters-open');
        }
      })
      .to('#filters-panel', 0, { left: '-100%', visibility: 'hidden', delay: 0.25 });
  }
}
